import { gql } from '@apollo/client';

export const GetProjectStatusQuery = gql`
  query GetProjectStatusQuery {
    getProject {
      ok
      error
      data
    }
  }
`;
